import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { OTCSSDData, OTCSSD } from '../../../interfaces/OT/OT-CSSD';
import {OTcssdApi} from '../api/OT-cssd.api';
 
@Injectable() 
export class OTCSSDService extends OTCSSDData{
 
  constructor(private api: OTcssdApi) {
    super();
  } 
  
  getall(url: string): Observable<OTCSSD[]> { 
    return this.api.getall(url);
  } 

  getById(url:string): Observable<OTCSSD>{
      return this.api.getby_id(url);
  }

  create(url: string, data:OTCSSD): Observable<OTCSSD[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:OTCSSD): Observable<OTCSSD> { 
    return this.api.update(url,data);
  }  

  list(url: string): Observable<any> {
    return this.api.list(url);
  }

  searchList(url: string,data:any): Observable<any> {  
    return this.api.searchList(url,data);
  }
}
